import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const ProductItem = ({ product, columnSize }) => {
    // Fallback to placeholder image if product.images is missing or empty
    const imageUrl = product?.images?.[0]?.url || 'https://via.placeholder.com/600x600.png?text=No+Image';

    // Round rating (example: 3.7 → 4)
    const rating = Math.round(product?.ratings || 0);

    const navigate = useNavigate();

    const goToFilters = () => {
        const q = new URLSearchParams();
        if (product?.category) q.set('category', product.category);
        q.set('all', '1'); // show all items in that category
        navigate(`/?${q.toString()}`);
    };

    const displayPrice = Number(product?.price || 0);

    return (
        <div className={`col-6 col-sm-6 col-md-4 col-lg-${columnSize} my-3`}>
            <div className="product-card  p-3 rounded-4 shadow-sm">
                <img
                    className="card-img-top mx-auto d-block"
                    src={imageUrl}
                    style={{ cursor: 'pointer' }}
                    onClick={goToFilters}
                    onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = 'https://via.placeholder.com/600x600.png?text=No+Image';
                    }}
                    alt={product?.name || "Product"}
                />

                <div className="card-body text-center">
                    <h5 className="card-title">
                        <Link
                            to={`/?${product?.category ? `category=${encodeURIComponent(product.category)}&` : ''}all=1`}
                            className="product-link"
                        >
                            {product?.name || "Unnamed Product"}
                        </Link>
                    </h5>

                    {/* Variants are selected only on Product Details page */}

                    <div className="ratings d-flex align-items-center justify-content-left mb-2 mt-3">
                        {[...Array(5)].map((_, i) => (
                            <i
                                key={i}
                                className={`fa fa-star ${i < rating ? "text-warning" : "text-secondary"}`}
                            ></i>
                        ))}
                        <span className="ms-2 text-muted">
                            ({product?.numOfReviews || 0})
                        </span>
                    </div>

                    <p className="price mb-2">
                        PKR {displayPrice.toFixed(2)}
                    </p>

                    <Link to={`/product/${product?._id}`} className="btn View-btn ">
                        View Details
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ProductItem;

